export const SET_USER_SETTING = 'SET_USER_SETTING';
export const LOAD_USER_SETTINGS = 'LOAD_USER_SETTINGS';
export const LOAD_USER_SETTINGS_SUCCESS = 'LOAD_USER_SETTINGS_SUCCESS';
export const LOAD_USER_SETTINGS_FAILED = 'LOAD_USER_SETTINGS_FAILED';

export const setUserSetting = ({ setting, value, scribeId }) => ({ type: SET_USER_SETTING, setting, value, scribeId });

export const loadUserSettings = () => ({
  type: LOAD_USER_SETTINGS
});

export const loadUserSettingsSuccess = settings => ({
  type: LOAD_USER_SETTINGS_SUCCESS,
  settings
});

export const loadUserSettingsFailed = error => ({
  type: LOAD_USER_SETTINGS_FAILED,
  error
});
